import { Grid, GridItem } from "@chakra-ui/react";

import { Textarea } from "../../textarea/textarea";
import { RadioGroup } from "../../radio/radio";

import { Radio } from "../../radio/radio";
import { QuestionWithHeaderAndFooter } from "../question";
import { buildImgixUrl } from "@/lib";

import { QuestionContent } from "../question-content";

import { RadioQuestionProps } from "../types";

export const RadioButtonQuestion = (props: RadioQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    questionLabel,
    questionId,
    accessibilityTextOfRequired,
    questionLabelProps,
    questionLabelType,
    layoutProps,
    contentLayoutProps,
    answer,
    size,
    minImageWidth = 300,
    disabled,
    handleChange,
    answerStackSpacing,
    options,
    showTextAnswer,
    otherAnswer,
    otherAnswerClassName,
    otherAnswerSize,
    otherAnswerProps,
    isHorizontal,
    handleOtherAnswer,
    answerProps,
    getRadioOptionDataTestId,
    radioOtherTextDataTestId,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    labelClassName,
    layoutProps,
    questionId,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent {...contentLayoutProps}>
        <RadioGroup
          value={answer}
          onValueChange={(details) => handleChange(details.value ?? "")}
          size={size}
        >
          <Grid
            templateColumns={{
              lg: isHorizontal ? `repeat(auto-fill, ${minImageWidth}px)` : "1fr"
            }}
            alignItems="baseline"
            gap={answerStackSpacing}
          >
            {options &&
              options
                .filter((option) => !option.supportsTextAnswer)
                .map((option) => (
                  <GridItem
                    key={option.id}
                    css={{
                      "@-moz-document url-prefix()": {
                        alignSelf: "normal"
                      }
                    }}
                  >
                    <Radio
                      value={option.id}
                      imageSrc={buildImgixUrl(option.imageUrl)}
                      imageAlt={option.imageAltText || option.name}
                      minH={{ base: "44px", lg: "auto" }}
                      {...answerProps}
                      data-testid={getRadioOptionDataTestId?.(option)}
                    >
                      {option.name}
                    </Radio>
                  </GridItem>
                ))}
          </Grid>
          {options &&
            options
              .filter((option) => option.supportsTextAnswer)
              .map((option) => (
                <Radio
                  key={option.id}
                  mt={answerStackSpacing}
                  value={option.id}
                  imageSrc={buildImgixUrl(option.imageUrl)}
                  imageAlt={option.imageAltText || option.name}
                  {...answerProps}
                  data-testid={getRadioOptionDataTestId?.(option)}
                >
                  {option.name}
                </Radio>
              ))}
        </RadioGroup>
        {showTextAnswer && (
          <Grid templateColumns="repeat(12, 1fr)">
            <GridItem colSpan={{ base: 12, lg: 10, "2xl": 4 }}>
              <Textarea
                required
                aria-label={showTextAnswer.name}
                disabled={disabled}
                value={otherAnswer}
                onChange={handleOtherAnswer}
                className={otherAnswerClassName}
                size={otherAnswerSize}
                {...otherAnswerProps}
                data-testid={radioOtherTextDataTestId}
              />
            </GridItem>
          </Grid>
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
